"use client";

import { getToolName } from "ai";
import { useEffect, useRef } from "react";
import type { ChatLogContext } from "@/lib/ai/chat-message-renderer-contract";
import { shouldReportToolFailure } from "@/lib/ai/tools/tool-error-policy";
import { logger } from "@/lib/logger";
import type { ToolRenderPlan } from "./render-model";

function useToolFailureLog(
  part: ToolRenderPlan["part"],
  logContext?: ChatLogContext,
) {
  const previousState = useRef(part.state);
  useEffect(() => {
    const before = previousState.current;
    previousState.current = part.state;
    if (part.state !== "output-error" || before === "output-error") return;
    if (!shouldReportToolFailure(getToolName(part), part.errorText)) {
      return;
    }
    logger.error(new Error("AI tool execution failed"), {
      chatId: logContext?.chatId ?? null,
      workspaceId: logContext?.workspaceId ?? null,
      model: logContext?.model ?? null,
      currentUrl: logContext?.currentUrl ?? null,
      chatUrl: logContext?.chatUrl ?? null,
      toolName: getToolName(part),
      toolType: part.type,
      toolCallId: part.toolCallId ?? null,
      errorText: part.errorText ?? null,
      toolState: part.state,
    });
  }, [part, logContext]);
}

/** tool の表示先が複数あっても、失敗遷移は plan ごとに一度だけ記録する。 */
export function ToolFailureObserver({
  plan,
  logContext,
}: {
  plan: ToolRenderPlan;
  logContext?: ChatLogContext;
}): null {
  useToolFailureLog(plan.part, logContext);
  return null;
}
